<template>
  <div class="inline-flex">
      <button v-show="isHidden" v-on:click="isHidden = !isHidden" class="bg-transparent inline-block p-0 text-indigo-500"><i aria-hidden="true" class="material-icons align-middle text-3xl">add_box</i></button>
      <div v-if="!isHidden" class="dropdown flex w-56 transition items-center">
          <div class="flex-1 pr-1 w-10/12">
            <v-select
              :options="options"
              label="name"
              v-model="selected"
              :placeholder="placeholder"
              class="text-xs leading-normal"
              >
                <template v-slot:option="option">
                  <div class="py-2 -my-1 border-b border-gray-300">
                      <strong>{{ option.name }}</strong>
                      <div v-if="option.internal_notes" class="bg-yellow-200 -mx-2 px-2 py-1 whitespace-normal text-xs text-gray-700 font-normal"> {{ option.internal_notes }}</div>
                    </div>
                </template>
              </v-select>
          </div>
          <div class="w-2/12">
              <button v-if="selected" v-on:click="postItem" type="submit" class="commitbutton p-0 inline-block"><i aria-hidden="true" class="material-icons align-middle text-3xl">check</i></button>
          </div>
        
      </div>
 
  </div>
</template>

<script>
    import VueSelect from 'vue-select';
    import axios from 'axios'

    export default {

        components: { VueSelect },

        props: {
            options: '',
            placeholder: {
                default: 'Add Item' 
            },
            route:'',
            idname:''
        },

        data() {
          return {
            isHidden: true,
            success: false,
            loaded: true,
            groupId: '',
            name: '',
            selected: '',
          }
        },

        methods: {

          postItem: function (event) {
            if (this.loaded) {
              this.loaded = false;
              this.success = false;
              $( ".commitbutton").addClass( "loading" );
              axios.post(
                  this.route.replace("selected.id", this.selected.id)
                ).then(function (response) {
                  console.log(response);
                }).then(function (event) {
                  location.reload();
                })
            };
          }

        },

    }
</script>
